<ng-container *ngIf="{ adConfigs: initialAdConfigMap$ | async } as subs">
  <div class="ad-skin">
    <div class="d-none d-xl-block">
      <flo-lazy
        [componentConstructor]="AdComponent"
        [initialProps]="subs.adConfigs | mapGet: 'skin'"
        (componentLoaded)="loadedAdsPush($event)"
      ></flo-lazy>
    </div>
  </div>
  <flo-lazy
    [componentConstructor]="AdComponent"
    [initialProps]="subs.adConfigs| mapGet: 'interstitial'"
    (componentLoaded)="loadedAdsPush($event)"
  ></flo-lazy>
  <flo-header-layout>
    <flo-lazy
      leaderboard-large
      class="leaderboard-center"
      [componentConstructor]="AdComponent"
      [initialProps]="subs.adConfigs | mapGet: 'leaderboard-lg'"
      [detectorHeight]="90"
      [detectorWidth]="728"
      (componentLoaded)="loadedAdsPush($event)"
    ></flo-lazy>
    <flo-lazy
      leaderboard-small
      class="leaderboard-center"
      [componentConstructor]="AdComponent"
      [initialProps]="subs.adConfigs | mapGet: 'leaderboard-sm'"
      [detectorHeight]="90"
      [detectorWidth]="728"
      (componentLoaded)="loadedAdsPush($event)"
    ></flo-lazy>
    <flo-lazy
      mobile-ad
      [componentConstructor]="AdComponent"
      [initialProps]="subs.adConfigs | mapGet: 'rectangle-mobile'"
      [detectorHeight]="200"
      [detectorWidth]="300"
      [threshold]="0.25"
      (componentLoaded)="loadedAdsPush($event)"
    ></flo-lazy>
    <flo-collection
      [props]="collectionComponentProps$ | async"
      [cta]="cta$ | async"
      header
    ></flo-collection>
    <old-flo-tabs tabs *ngIf="tabs$ | async as tabs">
      <old-flo-tab
        *ngFor="let tab of tabs"
        [tabTitle]="tab.displayName"
        [route]="tab.route"
        [active]="tab.active"
        [qp]="queryParams$ | async"
      >
      </old-flo-tab>
    </old-flo-tabs>
    <div sidebar>
      <div
        class="px-md-4 mx-md-2 mb-2"
        *ngIf="nodeListWidgetProps$ | async as widgetProps"
      >
        <flo-node-list-widget [props]="widgetProps"> </flo-node-list-widget>
      </div>
    </div>
    <flo-lazy
      sidebar-ad-sticky
      [componentConstructor]="AdComponent"
      [initialProps]="subs.adConfigs | mapGet: 'rectangle-sticky'"
      [detectorHeight]="200"
      [detectorWidth]="300"
      [threshold]="0.25"
      (componentLoaded)="loadedAdsPush($event)"
    ></flo-lazy>
    <flo-lazy
      sidebar-ad
      [componentConstructor]="AdComponent"
      [initialProps]="subs.adConfigs | mapGet: 'rectangle-1'"
      [detectorHeight]="200"
      [detectorWidth]="300"
      [threshold]="0.25"
      (componentLoaded)="loadedAdsPush($event)"
    ></flo-lazy>
    <div footer *ngIf="collectionComponentProps$ | async as props">
      <span class="d-md-none mobile-footer-cta">
        <flo-collection-cta
          data-test="collection-primary-cta-footer"
          [cta]="cta$ | async"
          [coreNodeId]="props.collectionId"
          [collectionType]="props.collectionType"
          [isUserLoggedIn]="props.isUserLoggedIn"
          classes="btn-lg"
        ></flo-collection-cta>
      </span>
      <div class="adhesion-ad position-static">
        <flo-lazy
          [componentConstructor]="AdComponent"
          [initialProps]="subs.adConfigs | mapGet: 'adhesion'"
          (componentLoaded)="loadedAdsPush($event)"
        ></flo-lazy>
      </div>
    </div>
  </flo-header-layout>
</ng-container>
